import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe {
  transform(array: Array<object>, args: string): Array<object> {
    if (array && array.length > 0 && args) {
      array.sort((a: any, b: any) => {
        if (a[args] < b[args]) {
          return -1;
        } else if (a[args] > b[args]) {
          return 1;
        } else {
          return 0;
        }
      });
      return array;
    } else {
      return array;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/order.pipe.ts